import { FilterSearch } from "../filter-search.model";

export class UserListFilters {
  public static filterSearch: FilterSearch = {
    filterSearchValue: "",
  };
}
